var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "app-container bj-label-colon label-width-6 bj-el-input-disabled",
    },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("DetailsOfThirdPartySalesOrder.Order")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("backText"))),
              ]),
              !_vm.$store.getters.cusId
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.showLog } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("DetailsOfThirdPartySalesOrder.log"))
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "bj-row mt20" },
        [
          _vm.orderInfoVO.circulationStatus == 0
            ? [
                _c(
                  "div",
                  { staticClass: "bj-col bj-col-14 circulation-status" },
                  [
                    _vm._m(0),
                    _c("div", [
                      _c("div", { staticClass: "bj-form-item" }, [
                        _c(
                          "div",
                          { staticClass: "bj-formItemLabel auto-width" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "DetailsOfThirdPartySalesOrder.Circulation"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "bj-form-item-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("DetailsOfThirdPartySalesOrder.Normal")
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "bj-form-tips" }, [
                        _vm._v(
                          _vm._s(_vm.$t("DetailsOfThirdPartySalesOrder.party"))
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm.orderInfoVO.circulationStatus == 1
            ? [
                _c(
                  "div",
                  { staticClass: "bj-col bj-col-14 circulation-status" },
                  [
                    _vm._m(1),
                    _c("div", [
                      _c("div", { staticClass: "bj-form-item" }, [
                        _c("div", { staticClass: "bj-formItemLabel" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "DetailsOfThirdPartySalesOrder.Circulation"
                              )
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "bj-form-item-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("DetailsOfThirdPartySalesOrder.Suspend")
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "bj-form-item" }, [
                        _c("div", { staticClass: "bj-formItemLabel" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("DetailsOfThirdPartySalesOrder.Reason")
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "bj-form-item-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                _vm.LANG_ZH_EN_PS_LIST.bjGet(
                                  _vm.orderInfoVO.failureReason
                                )
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "bj-row mt20" },
        [
          _c(
            "div",
            { staticClass: "bj-col bj-col-12" },
            [
              _c("div", { staticClass: "bj-form-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("DetailsOfThirdPartySalesOrder.information")
                    ) +
                    " "
                ),
                !_vm.isOrderInfoVOEdit &&
                _vm.orderInfoVO.circulationStatus == "1" &&
                _vm.$route.query.type != "view" &&
                !_vm.isReciverEdit
                  ? _c(
                      "span",
                      {
                        staticClass: "link right",
                        on: { click: _vm.showOrderInfoVOEdit },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("InternalSalesOrderDetails.Modify"))
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.isOrderInfoVOEdit
                  ? _c(
                      "span",
                      {
                        staticClass: "link right",
                        staticStyle: { "margin-left": "10px" },
                        on: { click: _vm.saveOrderInfoVO },
                      },
                      [_vm._v(_vm._s(_vm.$t("saveText")))]
                    )
                  : _vm._e(),
                _vm.isOrderInfoVOEdit
                  ? _c(
                      "span",
                      {
                        staticClass: "link right",
                        on: { click: _vm.cancelOrderInfoVOEdit },
                      },
                      [_vm._v(_vm._s(_vm.$t("cancelText")))]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("DetailsOfThirdPartySalesOrder.Trantypesaction")
                    )
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          _vm.ORDER_BUSINESS_TYPE_LIST.bjGet(
                            _vm.orderInfoVO.businessType
                          )
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(
                    _vm._s(_vm.$t("DetailsOfThirdPartySalesOrder.number"))
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "bj-form-item-value" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.orderInfoVO.webReference))]),
                    _c("BjCopyIcon", {
                      attrs: { copy: _vm.orderInfoVO.webReference },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("DetailsOfThirdPartySalesOrder.Sales"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(" " + _vm._s(_vm.orderInfoVO.storeName) + " "),
                  _c("span", { staticClass: "F68710" }, [
                    _vm._v(
                      "（" +
                        _vm._s(
                          _vm.SCHL_CHANNEL_TYPE.bjGet(_vm.orderInfoVO.channel)
                        ) +
                        "）"
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.OrderDate"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("timeFilters")(
                          _vm.orderInfoVO.orderTime,
                          _vm.orderInfoVO.orderTime
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(
                    _vm._s(_vm.$t("DetailsOfThirdPartySalesOrder.pulling"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("timeOperateTwoHour")(
                        _vm.orderInfoVO.creationDate,
                        _vm.orderInfoVO.creationDate
                      )
                    )
                  ),
                ]),
              ]),
              _vm.orderInfoVO.shippingMethod == "CSG MANUAL"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "BusinessThirdOrderAdd.deliveryAppointmentTime"
                          )
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bj-form-item-value" },
                      [
                        !_vm.isOrderInfoVOEdit
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("timeFilters")(
                                    _vm.orderInfoVO.deliveryAppointmentTime,
                                    _vm.orderInfoVO.deliveryAppointmentTime
                                  )
                                )
                              ),
                            ])
                          : _c("BjDateTimerPicker", {
                              model: {
                                value: _vm.orderInfoVO.deliveryAppointmentTime,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderInfoVO,
                                    "deliveryAppointmentTime",
                                    $$v
                                  )
                                },
                                expression:
                                  "orderInfoVO.deliveryAppointmentTime",
                              },
                            }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("SalesOrderToBeApproved.Merchant"))),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "bj-form-item-value",
                    class: { "order-remark-content": !_vm.isOrderInfoVOEdit },
                  },
                  [
                    !_vm.isOrderInfoVOEdit
                      ? [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.orderInfoVO.orderRemarks,
                                disabled: !_vm.orderInfoVO.orderRemarks,
                                placement: "top-start",
                                "popper-class": "csg-order-remark-tooltip",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "ellipsis order-remark-text" },
                                [_vm._v(_vm._s(_vm.orderInfoVO.orderRemarks))]
                              ),
                            ]
                          ),
                          _vm.orderInfoVO.orderRemarks
                            ? _c("BjCopyIcon", {
                                staticClass: "link order-remark-copy",
                                attrs: { copy: _vm.orderInfoVO.orderRemarks },
                              })
                            : _vm._e(),
                        ]
                      : _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.PRIORITY,
                            placeholder: _vm.$t("inputText"),
                          },
                          model: {
                            value: _vm.orderInfoVO.orderRemarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.orderInfoVO, "orderRemarks", $$v)
                            },
                            expression: "orderInfoVO.orderRemarks",
                          },
                        }),
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("RefundOnlyToBeReviewed.form.service"))),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "bj-form-item-value",
                    class: { "order-remark-content": !_vm.isOrderInfoVOEdit },
                  },
                  [
                    !_vm.isOrderInfoVOEdit
                      ? [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.orderInfoVO.serviceRemarks,
                                disabled: !_vm.orderInfoVO.serviceRemarks,
                                placement: "top-start",
                                "popper-class": "csg-order-remark-tooltip",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "ellipsis order-remark-text" },
                                [_vm._v(_vm._s(_vm.orderInfoVO.serviceRemarks))]
                              ),
                            ]
                          ),
                          _vm.orderInfoVO.serviceRemarks
                            ? _c("BjCopyIcon", {
                                staticClass: "link order-remark-copy",
                                attrs: { copy: _vm.orderInfoVO.serviceRemarks },
                              })
                            : _vm._e(),
                        ]
                      : _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.PRIORITY,
                            placeholder: _vm.$t("inputText"),
                          },
                          model: {
                            value: _vm.orderInfoVO.serviceRemarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.orderInfoVO, "serviceRemarks", $$v)
                            },
                            expression: "orderInfoVO.serviceRemarks",
                          },
                        }),
                  ],
                  2
                ),
              ]),
              _vm.orderInfoVO.storeCode == "CO00000658"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("DetailsOfThirdPartySalesOrder.dodgeCompany")
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.orderInfoVO.ecommerceOrderRef)),
                    ]),
                  ])
                : _vm._e(),
              _vm.orderInfoVO.storeCode == "CO00000658"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("DetailsOfThirdPartySalesOrder.dodgeAccount")
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.orderInfoVO.siteListingId)),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder2.means"))),
                ]),
                _c(
                  "div",
                  { staticClass: "bj-form-item-value" },
                  [
                    !_vm.isOrderInfoVOEdit
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.orderInfoVO.shippingMethod)),
                        ])
                      : _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.CSG_ORDER_SHIPPING_METHODS_LIST,
                          },
                          on: { change: _vm.onShippingMethod },
                          model: {
                            value: _vm.orderInfoVO.shippingMethod,
                            callback: function ($$v) {
                              _vm.$set(_vm.orderInfoVO, "shippingMethod", $$v)
                            },
                            expression: "orderInfoVO.shippingMethod",
                          },
                        }),
                  ],
                  1
                ),
              ]),
              _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL" ||
              _vm.orderInfoVO.shippingMethod == "CSG MANUAL"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("WarehouseManagement.form.chooseLogistics")
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bj-form-item-value" },
                      [
                        !_vm.isOrderInfoVOEdit
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.orderInfoVO.logisticsBusinessName)
                              ),
                            ])
                          : _c("BjSelectLov", {
                              attrs: {
                                disabled: !_vm.isOrderInfoVOEdit,
                                "option-list": _vm.LogisticsSelectionData,
                              },
                              on: { change: _vm.logsome },
                              model: {
                                value: _vm.orderInfoVO.logisticsBusinessName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderInfoVO,
                                    "logisticsBusinessName",
                                    $$v
                                  )
                                },
                                expression: "orderInfoVO.logisticsBusinessName",
                              },
                            }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL" ||
              _vm.orderInfoVO.shippingMethod == "CSG MANUAL"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("OrdinaryOrderMix.LogisticsTable.logisticsNo")
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bj-form-item-value" },
                      [
                        !_vm.isOrderInfoVOEdit
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.orderInfoVO.logisticsNo)),
                            ])
                          : _c("BjInput", {
                              attrs: {
                                disabled: !_vm.isOrderInfoVOEdit,
                                clearable: "",
                              },
                              model: {
                                value: _vm.orderInfoVO.logisticsNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.orderInfoVO, "logisticsNo", $$v)
                                },
                                expression: "orderInfoVO.logisticsNo",
                              },
                            }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.check"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bj-form-item-value" },
                      [
                        _c("el-switch", {
                          attrs: {
                            disabled: !_vm.isOrderInfoVOEdit,
                            "active-color": "#082dc3",
                            "inactive-color": "",
                          },
                          model: {
                            value: _vm.orderInfoVO.isProvideSize,
                            callback: function ($$v) {
                              _vm.$set(_vm.orderInfoVO, "isProvideSize", $$v)
                            },
                            expression: "orderInfoVO.isProvideSize",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.need"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bj-form-item-value" },
                      [
                        !_vm.isOrderInfoVOEdit
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.orderInfoVO.palletQty)),
                            ])
                          : _c("BjInputNumber", {
                              attrs: {
                                disabled: !_vm.isOrderInfoVOEdit,
                                clearable: "",
                              },
                              model: {
                                value: _vm.orderInfoVO.palletQty,
                                callback: function ($$v) {
                                  _vm.$set(_vm.orderInfoVO, "palletQty", $$v)
                                },
                                expression: "orderInfoVO.palletQty",
                              },
                            }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.time"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bj-form-item-value" },
                      [
                        !_vm.isOrderInfoVOEdit
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.orderInfoVO.truckPickupTime)),
                            ])
                          : _c("BjDateTimerPicker", {
                              attrs: { disabled: !_vm.isOrderInfoVOEdit },
                              model: {
                                value: _vm.orderInfoVO.truckPickupTime,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderInfoVO,
                                    "truckPickupTime",
                                    $$v
                                  )
                                },
                                expression: "orderInfoVO.truckPickupTime",
                              },
                            }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL" &&
              !_vm.isOrderInfoVOEdit
                ? [
                    _c("div", { staticClass: "file" }, [
                      _c("div", { staticClass: "bj-formItemLabel" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("OrdinaryOrderMix.LogisticsTable.Shipment")
                          )
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "fileUpload" },
                        _vm._l(
                          _vm.info.orderInfoVO.shippingLabels,
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "fileUpload_right" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ellipsis link",
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadImageUrl(
                                          item.url,
                                          item.name
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("file" + _vm._s(index + 1) + ": "),
                                    ]),
                                    _vm._v(" " + _vm._s(item.name)),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]
                : _vm._e(),
              _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL" &&
              _vm.isOrderInfoVOEdit
                ? [
                    _c("div", { staticClass: "font12" }, [
                      _c("div", { staticClass: "bj-formItemLabel" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("OrdinaryOrderMix.LogisticsTable.Shipment")
                          ) + ":"
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "fileUpload2" },
                      [
                        _c(
                          "UploadFile",
                          {
                            ref: "UploadFileRef1",
                            staticClass: "avatar-uploader",
                            attrs: {
                              limit: 20,
                              "limit-size": 5 * 1024,
                              multiple: "",
                              "show-file-list": "",
                              accept:
                                "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx",
                              "accept-list": [
                                "image/jpeg",
                                "image/png",
                                ".csv",
                                ".pdf",
                                ".doc",
                                ".xlsx",
                              ],
                              "auto-upload": "",
                              "limit-hide": "",
                            },
                            on: { handleFileListChange: _vm.fileListChange1 },
                          },
                          [
                            _c(
                              "template",
                              { slot: "default" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { size: "small", type: "primary" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "BusinessImportHistory.page.SelectFile"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              !_vm.isOrderInfoVOEdit ||
              (_vm.isOrderInfoVOEdit && !_vm.$store.getters.cusId)
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "file",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _c("div", { staticClass: "bj-formItemLabel" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "OrdinaryOrderMix.LogisticsTable.Supporting"
                              )
                            ) + ":"
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "fileUpload" },
                          _vm._l(
                            _vm.info.orderInfoVO.orderMaterialList,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "fileUpload_right" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ellipsis link",
                                      on: {
                                        click: function ($event) {
                                          return _vm.downloadImageUrl(
                                            item.fileUrl,
                                            item.fileName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "file" + _vm._s(index + 1) + ": "
                                        ),
                                      ]),
                                      _vm._v(" " + _vm._s(item.fileName)),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm.isOrderInfoVOEdit && _vm.$store.getters.cusId
                ? [
                    _c("div", { staticClass: "font12" }, [
                      _c("div", { staticClass: "bj-formItemLabel" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("OrdinaryOrderMix.LogisticsTable.Supporting")
                          ) + ":"
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "fileUpload2" },
                      [
                        _c(
                          "UploadFile",
                          {
                            ref: "UploadFileRef2",
                            staticClass: "avatar-uploader",
                            attrs: {
                              limit: 20,
                              "limit-size": 5 * 1024,
                              multiple: "",
                              "show-file-list": "",
                              accept:
                                "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx",
                              "accept-list": [
                                "image/jpeg",
                                "image/png",
                                ".csv",
                                ".pdf",
                                ".doc",
                                ".xlsx",
                              ],
                              "auto-upload": "",
                              "limit-hide": "",
                            },
                            on: { handleFileListChange: _vm.fileListChange2 },
                          },
                          [
                            _c(
                              "template",
                              { slot: "default" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { size: "small", type: "primary" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "BusinessImportHistory.page.SelectFile"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm.$route.query.status == "2"
            ? _c("buyerInfoDialog", {
                attrs: {
                  "is-show-edit":
                    _vm.orderInfoVO.circulationStatus != 0 &&
                    _vm.$route.query.type != "view" &&
                    !_vm.isOrderInfoVOEdit,
                  "receiver-info-v-o": _vm.info.receiverInfoVO,
                },
                on: { saveReceiverInfo: _vm.saveReceiverInfo },
              })
            : _c("receivingInformation", {
                attrs: {
                  "is-show-edit":
                    _vm.orderInfoVO.circulationStatus != 0 &&
                    _vm.$route.query.type != "view" &&
                    !_vm.isOrderInfoVOEdit,
                  "receiver-info-v-o": _vm.info.receiverInfoVO,
                  "is-reciver-edit": _vm.isReciverEdit,
                },
                on: {
                  onEditReceiverInfo: _vm.onEditReceiverInfo,
                  saveReceiverInfo: _vm.saveReceiverInfo,
                  cancelReceiverInfo: _vm.cancelReceiverInfo,
                },
              }),
        ],
        1
      ),
      _c("div", { staticClass: "bj-row mt20" }, [
        _c(
          "div",
          { staticClass: "bj-col bj-col-24" },
          [
            _c(
              "el-tabs",
              {
                attrs: { type: "card" },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("DetailsOfThirdPartySalesOrder.Commodity"),
                      name: "first",
                    },
                  },
                  [
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            float: "left",
                            "margin-bottom": "10px",
                          },
                        },
                        [
                          _vm.isShow
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.SELECTED_BJ_EBC_ID.length == 0,
                                    type: "danger",
                                  },
                                  on: { click: _vm.onBatchDelete },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SalesOrderEntry.delete"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.isShow
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.onAddSome },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SalesOrderEntry.ordinary"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.isShow
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.onAddMore },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SalesOrderEntry.package"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { float: "right" } },
                        [
                          !_vm.isShow &&
                          _vm.orderInfoVO.circulationStatus == "1" &&
                          _vm.$route.query.type != "view"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      _vm.isShow = !_vm.isShow
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("editText")))]
                              )
                            : _vm._e(),
                          _vm.isShow
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      _vm.isShow = !_vm.isShow
                                      _vm.reFresh()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("cancelText")))]
                              )
                            : _vm._e(),
                          _vm.isShow
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.onSave },
                                },
                                [_vm._v(_vm._s(_vm.$t("saveText")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.thirdItemVO,
                          stripe: "",
                          border: "",
                          "row-style": _vm.rowStyleFun,
                        },
                        on: { "selection-change": _vm.handleSelectionChange },
                      },
                      [
                        _vm.isShow
                          ? _c("el-table-column", {
                              attrs: {
                                type: "selection",
                                width: "55",
                                align: "center",
                              },
                            })
                          : _vm._e(),
                        _c("el-table-column", {
                          attrs: {
                            type: "index",
                            label: _vm.$t(
                              "DetailsOfThirdPartySalesOrder.Serial"
                            ),
                            align: "center",
                            width: "60",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "innerSkuCode",
                            label: _vm.$t("ExternalOrders.newAdd.ProductSKU"),
                            "show-overflow-tooltip": "",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.innerSkuCode
                                          ? scope.row.standardSkuCode
                                          : ""
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "innerSkuName",
                            label: _vm.$t("ExternalOrders.newAdd.ProductName"),
                            "show-overflow-tooltip": "",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "standardSkuCode",
                            label: _vm.$t("ExternalOrders.newAdd.ExternalSku"),
                            "show-overflow-tooltip": "",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            label: _vm.$t(
                              "DetailsOfThirdPartySalesOrder.Quantity"
                            ),
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  !_vm.isShow
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.quantity)),
                                      ])
                                    : _c("BjInputNumber", {
                                        model: {
                                          value: scope.row.quantity,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "quantity", $$v)
                                          },
                                          expression: "scope.row.quantity",
                                        },
                                      }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "spuCode",
                            label: _vm.$t(
                              "OrdinaryOrderMix.OrderItemTable.SPU"
                            ),
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  !_vm.isShow
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.spuCode)),
                                      ])
                                    : _c("BjSelectLov", {
                                        attrs: {
                                          "option-list": scope.row.batchNumList,
                                          placeholder: _vm.$t(
                                            "OrdinaryOrderMix.OrderItemTable.SPU"
                                          ),
                                          clearable: "",
                                        },
                                        model: {
                                          value: scope.row.spuCode,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "spuCode", $$v)
                                          },
                                          expression: "scope.row.spuCode",
                                        },
                                      }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t(
                              "BusinessBatchInventoryQuery.table.usableNum2"
                            ),
                            prop: "usableNum",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  !scope.row.spuCode &&
                                  _vm.orderInfoVO.failureReason ==
                                    "批次库存不足"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.batchNumList &&
                                              scope.row.batchNumList.length > 0
                                              ? scope.row.batchNumTotal
                                              : ""
                                          )
                                        ),
                                      ])
                                    : scope.row.spuCode &&
                                      scope.row.batchNumList &&
                                      scope.row.batchNumList.length > 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.batchNumList.bjGet(
                                              scope.row.spuCode,
                                              "value",
                                              "usableNum"
                                            )
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t(
                              "BusinessThirdOrderAdd.form.Operation"
                            ),
                            align: "center",
                            fixed: "right",
                            width: "120",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        disabled: !_vm.isShow,
                                        type: "text",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDelete(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("delText")))]
                                  ),
                                  _vm.orderInfoVO.failureReason ==
                                    "批次库存不足" && !scope.row.spuCode
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onView(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("viewText")))]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "bj-form-tips",
                        staticStyle: { "margin-top": "15px" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "DetailsOfThirdPartySalesOrder.Totalproducts"
                              )
                            ) +
                            _vm._s(_vm.totalSkuNum) +
                            " ，" +
                            _vm._s(
                              _vm.$t(
                                "DetailsOfThirdPartySalesOrder.Totalnumber"
                              )
                            ) +
                            _vm._s(_vm.thirdItemVO.length) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                this.$store.state.user.permissionBtns.includes(
                  "BusinessGoodsPackageManagement".toLocaleLowerCase()
                )
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.package.Info"),
                          name: "second",
                        },
                      },
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.packageVO,
                              stripe: "",
                              border: "",
                              "header-cell-style": _vm.$rowStyle.DEFAULT,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("table.countText"),
                                type: "index",
                                width: "60",
                                align: "center",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "packingMethod",
                                label: _vm.$t("goodsPage.packingM"),
                                "show-overflow-tooltip": "",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.PACKAGE_TYPE_LIST.bjGet(
                                                scope.row.packingMethod
                                              )
                                            )
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1552549243
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "skuName",
                                label: _vm.$t("goodsPage.package.Name"),
                                "show-overflow-tooltip": "",
                                align: "center",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "skuCode",
                                label: _vm.$t("goodsPage.package.SKU"),
                                "show-overflow-tooltip": "",
                                align: "center",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "packageCount",
                                label: _vm.$t("goodsPage.package.num"),
                                "show-overflow-tooltip": "",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(_vm._s(scope.row.packageCount)),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                333218276
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "salesPriceSum",
                                label: _vm.$t("goodsPage.package.money1"),
                                "show-overflow-tooltip": "",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(_vm._s(scope.row.salesPriceSum)),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2873675251
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "activityPriceSum",
                                label: _vm.$t("goodsPage.package.money2"),
                                "show-overflow-tooltip": "",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          _vm._s(scope.row.activityPriceSum)
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1872156310
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm.totalOrderStatus == 5
        ? _c("div", { staticClass: "bj-row mt20" }, [
            _c(
              "div",
              { staticClass: "bj-col bj-col-24" },
              [
                _c(
                  "div",
                  {
                    staticClass: "bj-form-title",
                    staticStyle: {
                      float: "left",
                      "line-height": "2",
                      "margin-right": "30px",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("InternalSalesOrderDetails.Logistics"))
                    ),
                  ]
                ),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: [_vm.orderInfoVO],
                      stripe: "",
                      border: "",
                      "header-cell-style": _vm.$rowStyle.DEFAULT,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "webReference",
                        label: _vm.$t("InternalSalesOrderDetails.party"),
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "logisticsNo",
                        label: _vm.$t(
                          "OrdinaryOrderMix.LogisticsTable.logisticsNo"
                        ),
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "logisticsCompany",
                        label: _vm.$t(
                          "OrdinaryOrderMix.LogisticsTable.logisticsCompany"
                        ),
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "logisticsBusinessName",
                        label: _vm.$t(
                          "OrdinaryOrderMix.LogisticsTable.logisticsBusinessName"
                        ),
                        align: "center",
                        width: "200",
                      },
                    }),
                    !_vm.$store.getters.cusId
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "totalPrice",
                            label: _vm.$t(
                              "OrdinaryOrderMix.LogisticsTable.totalPrice"
                            ),
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.totalPrice
                                          ? (scope.row.totalPrice - 0).toFixed(
                                              2
                                            )
                                          : scope.row.totalPrice
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            721864411
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      (_vm.totalOrderStatus == 1 || _vm.totalOrderStatus == 2) &&
      _vm.isLogisticsShow
        ? _c("div", { staticClass: "bj-row mt20" }, [
            _c(
              "div",
              { staticClass: "bj-col bj-col-24" },
              [
                _c(
                  "div",
                  {
                    staticClass: "bj-form-title",
                    staticStyle: {
                      float: "left",
                      "line-height": "2",
                      "margin-right": "30px",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "OrdinaryOrderMix.LogisticsTable.PriceSearchResults"
                        )
                      )
                    ),
                  ]
                ),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.logisticsInfo,
                      stripe: "",
                      border: "",
                      "header-cell-style": _vm.$rowStyle.DEFAULT,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "provider",
                        label: this.$t(
                          "InternalSalesOrderDetailsSearchTable.providerss"
                        ),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "ratePrice",
                        label: this.$t("billingPage.ratePrice"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    scope.row.ratePrice
                                      ? (scope.row.ratePrice - 0).toFixed(2)
                                      : scope.row.ratePrice
                                  )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3705460763
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "responseCode",
                        label: this.$t(
                          "InternalSalesOrderDetailsSearchTable.responseCode"
                        ),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      trigger: "hover",
                                      placement: "top",
                                      content: scope.row.responseMsg,
                                      disabled: !scope.row.responseMsg,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "name-wrapper",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.responseCode) +
                                            " "
                                        ),
                                        scope.row.responseCode == "FAILED"
                                          ? _c("i", {
                                              staticClass: "el-icon-warning",
                                              staticStyle: { color: "red" },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1372880895
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("BjDialogList", {
        ref: "dialogListOrdinarySku",
        attrs: {
          width: "80%",
          config: _vm.$BjDialogListConfig.skuDefault(
            _vm.$t("SalesOrderEntry.goods"),
            {
              defaultQuery: {
                cusId: _vm.info.cusId,
                setFlag: 0,
                status: [3, 4, 5],
                itemType: "item",
              },
            }
          ),
          multiple: "",
        },
        on: { confirm: _vm.onAddGoodsDialogConfirm },
      }),
      _c("BjDialogList", {
        ref: "dialogListPackAgeSku",
        attrs: {
          width: "80%",
          config: _vm.$BjDialogListConfig.skuDefault(
            _vm.$t("SalesOrderEntry.Add"),
            {
              defaultQuery: {
                cusId: _vm.info.cusId,
                setFlag: 1,
                status: [3, 4, 5],
              },
            }
          ),
          multiple: "",
        },
        on: { confirm: _vm.onAddGoodsDialogConfirm },
      }),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.barcodeVisible, width: "500px" },
          on: {
            "update:visible": function ($event) {
              _vm.barcodeVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.barcodeList,
                border: "",
                script: "",
                "max-height": "600px",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "standardSkuCode",
                  label: _vm.$t("ExternalOrders.newAdd.ProductSKU"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "label",
                  label: _vm.$t("OrdinaryOrderMix.OrderItemTable.SPU"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "usableNum",
                  label: _vm.$t("BusinessBatchInventoryQuery.table.usableNum2"),
                  align: "center",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-icon-circle" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-icon-circle" }, [
      _c("i", { staticClass: "el-icon-warning-outline" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }